const DEFAULT_BUFFER_SIZE = 1024
const DEFAULT_GROWTH_FACTOR = 2

export class AppendableArrayBuffer {
  _buf: ArrayBuffer
  length: number = 0

  constructor() {
    this._buf = new ArrayBuffer(DEFAULT_BUFFER_SIZE)
  }

  append(data: ArrayBuffer) {
    if (this.length + data.byteLength > this._buf.byteLength) {
      let size = this._buf.byteLength * DEFAULT_GROWTH_FACTOR
      while (this.length + data.byteLength > size) {
        size *= DEFAULT_GROWTH_FACTOR
      }
      const newBuffer = new ArrayBuffer(size)
      new Uint8Array(newBuffer).set(new Uint8Array(this._buf))
      this._buf = newBuffer
    }

    new Uint8Array(this._buf).set(new Uint8Array(data), this.length)
    this.length += data.byteLength
  }

  expand(size: number) {
    if (size > this._buf.byteLength) {
      const newBuffer = new ArrayBuffer(size)
      new Uint8Array(newBuffer).set(new Uint8Array(this._buf))
      this._buf = newBuffer
    }
  }

  uint8Array() {
    return new Uint8Array(this._buf, 0, this.length)
  }

  buffer() {
    return this._buf.slice(0, this.length)
  }
}
